import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Textarea, ENoBorderRadius } from '../../../components/packages/Textarea';
import { getComments } from '../../../selectors/comments';
import { setMainComment } from '../../../actions/comments';
import { useIsCommentDisabled } from '../utils';
import { trackCommentAdd, ECommentType } from '../tracking';
import { useIsReportStatusFinished } from '../../../utils/report/useIsReportStatusFinished';

export const MainCommentContainer: React.FC = () => {
  const dispatch = useDispatch();
  const isReportStatusFinished = useIsReportStatusFinished();
  const { mainComment } = useSelector(getComments);
  const commentDisabled = useIsCommentDisabled();

  const onHandleChange = React.useCallback(
    (value: string) => {
      dispatch(setMainComment(value));
    },
    [dispatch],
  );

  const onHandleBlur = React.useCallback(() => {
    if (mainComment) {
      trackCommentAdd(ECommentType.General);
    }
  }, [mainComment]);

  if (isReportStatusFinished && !mainComment) {
    return null;
  }

  return (
    <Textarea
      placeholder="Оставьте комментарий клиенту"
      value={mainComment}
      onChange={onHandleChange}
      onBlur={onHandleBlur}
      limit={300}
      disabled={commentDisabled}
      noBorderRadius={commentDisabled ? ENoBorderRadius.TopRight : undefined}
    />
  );
};

MainCommentContainer.displayName = 'MainCommentContainer';
